import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { LineAccountUser } from '@/types/user';

export const getLineUsers = async (): Promise<ApiResult<LineAccountUser[]>> => {
  const { status, result } = await callApi<LineAccountUser[]>(`line/users`, 'GET');
  return { status, result };
};
